
      let Page = require('/home/toannc/ekmap-platform-map-javascript/docs/pages/maps/realestate.md');
      Page = Page.default || Page;
      module.exports = {
        component: Page,
        props: {
  "frontMatter": {
    "title": "Bản đồ bất động sản",
    "description": "Hiển thị bản đồ Bất động sản",
    "topics": [
      "Bản đồ"
    ],
    "thumbnail": "admin-map",
    "order": 6,
    "contentType": "example",
    "layout": "page",
    "hideFeedback": false,
    "language": [
      "JavaScript"
    ],
    "products": [
      "Mapbox GL JS"
    ],
    "prependJs": [
      "import Example from '../../components/example';",
      "import html from './realestate.html';"
    ]
  }
}
      };
    